<div class="scanner-wrapper">

   <zxing-scanner
    #scanner
    [formats]="formats"
    [device]="currentDevice"
    [torch]="torchEnabled"
    [tryHarder]="true"
    (scanSuccess)="onCodeResult($event)"
    (camerasFound)="onCamerasFound($event)"
    (permissionResponse)="onHasPermission($event)"
    (torchCompatible)="torchAvailable = $event">
  </zxing-scanner>

 
  <div class="scanner-overlay">
    <div class="scan-line" [class.processing]="isProcessing"></div>
    <div class="instructions">
      <p *ngIf="!isProcessing">Placez le code-barres dans le cadre</p>
      <p *ngIf="isProcessing" class="processing-text">
        <span class="spinner"></span> Traitement...
      </p>
    </div>
  </div>

  <div class="controls" *ngIf="!isProcessing">
    <button class="control-btn" (click)="switchCamera()" *ngIf="availableDevices.length > 1">🔄</button>
    <button class="control-btn" (click)="toggleTorch()" *ngIf="torchAvailable" [class.active]="torchEnabled">
      {{ torchEnabled ? '🔦' : '💡' }}
    </button>
  </div>
</div>